<div class="[ cluster cluster-space-2xs ]">
  <div class="flex-nowrap" [class.opacity-low]="disabled">
    @if (leadingIcon) {
      <dcr-icon [attr.icon]="leadingIcon" class="campus-icon icon-current"></dcr-icon>
    }

    <span class="[ label-large truncate ]"><ng-content></ng-content></span>

    @if (trailingIcon) {
      <dcr-icon [attr.icon]="trailingIcon" class="campus-icon icon-current"></dcr-icon>
    }
  </div>
</div>

@if (badge) {
  <dcr-badge [count]="badge" class="[ absolute -top-3xs -right-3xs ]"></dcr-badge>
}

<dcr-state-layer class="bg-on-primary" [for]="element"></dcr-state-layer>
<dcr-focus-ring [for]="element"></dcr-focus-ring>
